module.exports = __webpack_public_path__ + "img/829.610aabeb.png";